<template>
  <b-modal @hide="modalClose" ref="partnerFixModal" :title="getTitle" size="md">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left">{{ $t('取引関係') }}</th>
            <td class="text-left">
              <template v-if="form.isCustomer && form.isSupplier">{{ $t('得意先') }} / {{ $t('仕入先') }}</template>
              <template v-else-if="form.isCustomer">{{ $t('得意先') }}</template>
              <template v-else>{{ $t('仕入先') }}</template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('管理番号') }}</th>
            <td class="text-left" colspan="5">
              <template v-if="form.partnerCode">
                {{ form.partnerCode }}
              </template>
              <template v-else>-</template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('取引先名') }}</th>
            <td class="text-left" colspan="5">
              <template v-if="form.partnerName">
                {{ form.partnerName }}
              </template>
              <template v-else>-</template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('送り先') }}</th>
            <td class="text-left" colspan="5">
              <div v-if="!unable" class="input-group w-100 position-relative">
                <input v-model="form.dest.name" type="search" class="form-control input" :disabled="destDisabled" @focus="mixinListToggle('fixDestName', true)" @blur="mixinListToggle('fixDestName', false)"/>
                <div class="input-group-append">
                  <button class="btn btn-light h-100" type="button"
                  @click="disabledRelease('destId')"
                  >{{ $t('選択解除') }}</button>
                </div>
                <div id="fixDestName" class="list-group searchList" style="display:none">
                  <a v-for="(item,index) in destList" :key="index" @click="existDest(item)" class="list-group-item list-group-item-action">{{ item.name }}/{{ item.code }}</a>
                </div>
              </div>
              <template v-if="unable">
                <template v-if="form.dest.name">
                  {{ form.dest.name }}
                </template>
                <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('手配元') }}</th>
            <td class="text-left" colspan="5">
              <div v-if="!unable" class="input-group w-100 position-relative">
                <input v-model="form.ordering.name" type="search" class="form-control input" :disabled="orderingDisabled" @focus="mixinListToggle('fixOrderingName', true)" @blur="mixinListToggle('fixOrderingName', false)"/>
                <div class="input-group-append">
                  <button class="btn btn-light h-100" type="button"
                  @click="disabledRelease('orderingId')"
                  >{{ $t('選択解除') }}</button>
                </div>
                <div id="fixOrderingName" class="list-group searchList" style="display:none">
                  <a v-for="(item,index) in orderingList" :key="index" @click="existOrdering(item)" class="list-group-item list-group-item-action">{{ item.name }}/{{ item.code }}</a>
                </div>
              </div>
              <template v-if="unable">
                <template v-if="form.ordering.name">
                  {{ form.ordering.name }}
                </template>
                  <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              <template v-if="isTypeSales">
                {{ $t('客先品番') }}
              </template>
              <template v-else>
                {{ $t('仕入先品番') }}
              </template>
            </th>
            <td class="text-left" colspan="5">
              <input v-if="!unable" v-model="form.partnerProductCode" type="text" class="form-control">
              <template v-if="unable">
                <template v-if="form.partnerProductCode">
                  {{ form.partnerProductCode }}
                </template>
                <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr v-if="isTypePurchase || isTypeMaterial">
            <th class="table-active text-left">{{ $t('発注コード') }}</th>
            <td class="text-left" colspan="5">
              <input v-if="!unable" v-model="form.orderCode" type="text" class="form-control">
              <template v-if="unable">
                <template v-if="form.orderCode">
                  {{ form.orderCode }}
                </template>
                <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr v-if="isTypePurchase || isTypeMaterial">
            <th class="table-active text-left">{{ $t('手配リードタイム') }}<span v-if="!unable" class="text-danger">&nbsp;{{ $t("※必須") }}</span></th>
            <td class="text-left" colspan="5">
              <div v-if="!unable" class="form-group">
                <div class="w-100">
                  <div class="input-group">
                    <input v-model.number="form.materialLeadTime" type="number" min="0" class="form-control">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        {{ $t('日') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="unable">
                <template v-if="form.materialLeadTime">
                  {{ form.materialLeadTime }}&nbsp;{{ $t('日') }}
                </template>
                <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr v-if="isTypeSales || isTypePurchase">
            <th class="table-active text-left">
                {{ $t('売単価') }}
            </th>
            <td class="text-left" colspan="5">
              <div v-if="!unable" class="form-group">
                <div class="w-100">
                  <div class="input-group">
                    <input v-model.number="form.salesPrice" type="number" min="0" class="form-control">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        {{ $t('円') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="unable">
                <template v-if="form.salesPrice">
                  {{ form.salesPrice | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
                </template>
                <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              <template v-if="isTypeMaterial">
                {{ $t('材料単価') }}<span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
              </template>
              <template v-else>
                {{ $t('仕入単価') }}
              </template>
            </th>
            <td class="text-left" colspan="5">
              <div v-if="!unable" class="form-group">
                <div class="w-100">
                  <div class="input-group">
                    <input v-model.number="form.purchasePrice" type="number" min="0" class="form-control">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        {{ $t('円') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="unable">
                <template v-if="form.purchasePrice">
                  {{ form.purchasePrice | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
                </template>
                <template v-else>-</template>
              </template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('適用日時') }}<span v-if="!unable" class="text-danger">&nbsp;{{ $t("※必須") }}</span></th>
            <td class="text-left" colspan="5">
              <template v-if="!unable">
                <div class="input-group">
                  <date-picker v-model="form.startDatetime" :config="datetimepicker.options"></date-picker>
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['far', 'clock']" />
                    </span>
                  </div>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    v-model="immediately"
                    class="form-check-input"
                    type="checkbox"
                    id="gridCheck3"
                  />
                  <label class="form-check-label" for="gridCheck3">
                    {{ $t("即時反映") }}</label>
                </div>
              </template>
              <template v-else>
                {{ form.startDatetime }}
              </template>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('備考') }}</th>
            <td class="text-left" colspan="5">
              <input v-if="!unable" v-model="form.note" type="text" class="form-control">
              <template v-if="unable">
                <template v-if="form.note">
                  {{ form.note }}
                </template>
                <template v-else>
                  -
                </template>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
          v-if="!unable"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { cloneDeep, debounce } from 'lodash'
import moment from 'moment/moment'
import { mapGetters } from 'vuex'

const format = {
  dest: {
    name: '',
  },
  ordering: {
    name: '',
  },
  destId: null,
  destName: '',
  id: null,
  isCustomer: false,
  isMaterialSupplier: false,
  isSupplier: false,
  orderingId: null,
  orderingName: '',
  partnerId: null,
  partnerName: '',
  partnerProductCode: '',
  productId: null,
  purchasePrice: null,
  salesPrice: null,
  startDatetime: null,
  orderCode: '',
  materialLeadTime: null,
  note: '',
}
export default {
  props: {
    productType: {
      type: String,
    },
  },
  data() {
    return {
      form: cloneDeep(format),
      contacts: [],
      type: '',
      destDisabled: false,
      orderingDisabled: false,
      registering: false,
      unable: false,
      error: '',
      immediately: false,
      orderingList: [],
      destList: [],
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(item, type) {
      if ('beforeSalesPrice' in item) this.unable = true
      const form = this.mixin_deepcopy(format)
      for (let key of Object.keys(item)) {
        if (item[key]) form[key] = item[key]
      }

      this.type = type
      form.isCustomer = this.form.isCustomer || false
      form.isSupplier = this.form.isSupplier || false
      form.isMaterialSupplier = this.form.isMaterialSupplier || false
      form.startDatetime = this.mixinTimestampToFormat(form.startDatetime, 'YYYY/MM/DD HH:mm')
      this.$refs.partnerFixModal.show()
      form.dest.name = form.destName || ''
      form.destName = ''
      form.ordering.name = form.orderingName || ''
      form.orderingName = ''
      if (form.dest.name) this.destDisabled = true
      if (form.ordering.name) this.orderingDisabled = true
      this.form = form
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.form = cloneDeep(format)
      if (this.unable) {
        this.registering = false
        this.contacts = []
        this.unable = false
        this.destDisabled = false
        this.orderingDisabled = false
        this.$refs.partnerFixModal.hide()
        return
      }

      this.$emit('modalClose')
      this.registering = false
      this.contacts = []
      this.unable = false
      this.destDisabled = false
      this.orderingDisabled = false
      this.immediately = false
      this.$refs.partnerFixModal.hide()
    },
    existDest(item) {
      this.form.dest.name = item.name
      this.form.destId = item.id
      this.destDisabled = true
    },
    existOrdering(item) {
      this.form.ordering.name = item.name
      this.form.orderingId = item.id
      this.orderingDisabled = true
    },
    // 選択を解除する処理
    disabledRelease(key) {
      this.form[key] = null
      switch (key) {
        case 'partnerId':
          this.partnerDisabled = false
          this.form.destId = null
          this.destDisabled = false
          this.form.orderingId = null
          this.orderingDisabled = false
          break
        case 'destId':
          this.form.destId = -1
          this.destDisabled = false
          break
        case 'orderingId':
          this.form.orderingId = -1
          this.orderingDisabled = false
      }
    },
    // 登録の処理
    async register() {
      const now = moment().format()
      if (this.isTypePurchase || this.isTypeMaterial) {
        if (!this.form.materialLeadTime) return this.error = this.$t('手配リードタイム') + this.$t('必須メッセージ')
        if (this.form.materialLeadTime < 0) return this.error = this.$t('手配リードタイムは0より大きい数字を入力して下さい')
        if (!this.form.purchasePrice) return this.error = this.$t('材料単価') + this.$t('必須メッセージ')
        if (this.form.purchasePrice < 0) return this.error = this.$t('材料単価は0より大きい半角数字を入力して下さい')
        if (this.isEmpty(this.form.startDatetime) && !this.immediately) {
          this.error = this.$t('適用日時') + this.$t('必須メッセージ')
          return
        }
      }
      if (moment(this.form.startDatetime).isSameOrBefore(now) && !this.immediately) {
        this.error = this.$t('現在時刻以降') + this.$t('必須メッセージ')
        return
      }
      if (this.form.purchasePrice === null && this.form.salesPrice === null) return this.error = this.$t('product.partner.add.price_required')
      this.error = ''
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        if (key === 'startDatetime') {
          if (this.immediately) {
            params[key] = moment().unix()
          } else {
            params[key] = moment(this.form[key]).unix()
          }
        } else if (key === 'dest' && this.form[key].name) {
          if (!this.form.destId || this.form.destId === -1) params[key] = this.form[key]
        } else if (key === 'ordering' && this.form[key].name) {
          if (!this.form.orderingId || this.form.orderingId === -1) params[key] = this.form[key]
        } else if (this.form[key] && key !== 'isCustomer' && key !== 'isMaterialSupplier' && key !== 'isSupplier' && key !== 'partnerId') {
          if (this.form[key]) params[key] = this.form[key]
        }
      }
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/product/partner`,
          params,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$emit('registered')
        this.$toasted.success(`${this.$t('データ登録完了メッセージ')}`)
        this.registering = false
        this.form = {
          dest: {
            name: '',
          },
          ordering: {
            name: '',
          },
        }
        this.contacts = []
        this.destDisabled = false
        this.orderingDisabled = false
        this.unable = false
        this.immediately = false
        this.$refs.partnerFixModal.hide()
      } catch (error) {
        this.$toasted.show(`${this.$t('データ登録エラーメッセージ')}`)
      }
      this.registering = false
    },
  },
  computed: {
    isTypeSales() {
      return this.type === 'ownbrand'
    },
    isTypePurchase() {
      return this.type === 'purchase'
    },
    isTypeMaterial() {
      return this.type === 'material'
    },
    getTitle() {
      if (this.isTypeMaterial) return this.$t('材料仕入先詳細')
      return this.$t('取引先詳細')
    },
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
  watch: {
    'form.ordering.name': debounce(async function(newVal) {
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/ordering/contacts`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          params: { partnerId: this.form.partnerId, name: newVal},
        }
      )
      if (res.status !== 200) return
      this.orderingList = res.data
    }, 250),
    'form.dest.name': debounce(async function(newVal) {
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/ordering/contacts`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          params: { partnerId: this.form.partnerId, name: newVal},
        }
      )
      if (res.status !== 200) return
      this.destList = res.data
    }, 250),
  },
}
</script>
